module.exports = __webpack_public_path__ + "media/pricing/HVAC-a92023d1.svg";